export const GENDER = {
  MALE: "Male",
  FEMALE: "Female",
};
